/**
 * Get step title by step number and analysis type
 */
function getStepTitle(stepNumber, analysisType) {
  const titles = {
    synchro_parser: {
      1: 'Extract CSV Data',
      2: 'Confirm Metadata',
      3: 'Parsing Options', // FEATURE-010
      4: 'Generate Outputs',
      5: 'Excel Generation',
    },
    volume_figure_generator: {
      1: 'Volume Input',
      2: 'Generate Preview',
      3: 'Review & Adjust',
      4: 'Finalize Output',
    },
  }
  return titles[analysisType]?.[stepNumber] || `Step ${stepNumber}`
}

/**
 * Visual step progress indicator
 * Shows horizontal stepper with step status
 * @param {number} currentStep - Current step number (0 = not started)
 * @param {Array} steps - Array of step objects
 * @param {string} analysisType - Type of analysis (synchro_parser, volume_figure_generator)
 */
function StepProgress({ currentStep, steps = [], analysisType = 'synchro_parser' }) {
  // Determine total steps based on analysis type
  const totalSteps =
    analysisType === 'synchro_parser' ? 5 : analysisType === 'volume_figure_generator' ? 4 : 5
  const stepNumbers = Array.from({ length: totalSteps }, (_, i) => i + 1)

  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {stepNumbers.map((stepNumber, index) => {
          const step = steps.find((s) => s.step_number === stepNumber)
          const isCompleted = currentStep > stepNumber
          const isActive = currentStep === stepNumber

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              {/* Step circle */}
              <div className="flex flex-col items-center relative flex-1">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
                    border-2 transition-colors
                    ${
                      isCompleted
                        ? 'bg-green-500 border-green-500 text-white'
                        : isActive
                          ? 'bg-blue-500 border-blue-500 text-white'
                          : 'bg-gray-100 border-gray-300 text-gray-500'
                    }
                    ${step?.status === 'failed' ? 'bg-red-500 border-red-500 text-white' : ''}
                  `}
                >
                  {isCompleted ? '✓' : stepNumber}
                </div>

                {/* Step label */}
                <div className="mt-2 text-center">
                  <div
                    className={`text-xs font-medium ${
                      isActive ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-gray-500'
                    }`}
                  >
                    {getStepTitle(stepNumber, analysisType)}
                  </div>
                  {step && (
                    <div className="text-xs text-gray-500 mt-0.5 capitalize">
                      {step.status === 'awaiting_user' ? 'Needs Input' : step.status}
                    </div>
                  )}
                </div>
              </div>

              {/* Connector line (except after last step) */}
              {index < totalSteps - 1 && (
                <div
                  className={`
                    h-0.5 flex-1 -mt-8
                    ${isCompleted ? 'bg-green-500' : 'bg-gray-300'}
                  `}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default StepProgress
